import React, { Component, Fragment } from "react";
import { Upload, Button, message, Progress, Form } from 'antd';
import { getDownloadSpace } from "@/fetch/api/personal";
import classnames from 'classnames';
import { Local } from '@/utils/local';
import { Decrypt } from '@/utils/encrypt';
import './index.less';
import Zmage from 'react-zmage';

class Group extends Component {
  state = {
    imgArr: []
  };

  componentDidMount() {
    if (this.props.data.fileImageValues) {
      let fileImageOption = this.props.data.fileImageValues || this.props.data.colOption;
      let arr = fileImageOption.map(value => ({
        id: value.id,
        resourceId: value.resourceListId || value.resourceId || value.uploadResourceId
      }));
      this.setState({
        imgArr: arr
      }, () => {
        this.props.handleImg({
          [this.props.data.fieldId]: this.state.imgArr
        });
      });
    } // 完善信息字段


    if (this.props.data.dataImages && this.props.data.dataImages.length) {
      let arr = this.props.data.dataImages.map(value => ({
        id: value.fileId,
        resourceId: value.uploadResourceId
      }));
      this.setState({
        imgArr: arr
      }, () => {
        this.props.handleImg({
          [this.props.data.fieldId]: this.state.imgArr
        });
      });
    }
  }

  handleImg = img => {
    let arr = this.state.imgArr;

    if (arr.length && arr.findIndex(value => value.id === img.id) !== -1) {
      arr.forEach(value => {
        if (value.id === img.id) {
          value.resourceId = img.resourceId;
        }
      });
    } else {
      arr.push(img);
    }

    this.setState({
      imgArr: arr
    }, () => {
      this.props.handleImg({
        [this.props.data.fieldId]: this.state.imgArr
      });
    });
  };

  render() {
    const {
      data
    } = this.props;
    data.colValue && data.colValue.length ? data.fileImageValues = data.colValue : null; // 完善信息dataImages； 代报考fileImageValues fieldOptions

    const arr = data.dataImages || data.fileImageValues || data.fieldOptions || [];
    return <div data-inspector-line="60" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" className="img-group-wrap cf">
        {arr.map((value, index) => <ImgContainer data-inspector-line="62" data-inspector-column="36" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" deductionSpaceFlag={this.props.deductionSpaceFlag} imageUrl={value.sourcePath || value.fileValueUrl || value.pathUrl || ''} key={index} id={value.id || value.fileId} elem={value} data={this.props.data} form={this.props.form} defaultValue={value.resourceListId || value.resourceId || ''} handleImg={this.handleImg} />)}
      </div>;
  }

}

class ImgContainer extends Component {
  state = {
    loading: false,
    percent: 0,
    imageUrl: ''
  };

  componentDidMount() {
    this.initSpace();

    if (this.props.imageUrl) {
      this.setState({
        imageUrl: this.props.imageUrl
      });
    }
  }

  initSpace = () => {
    // 储存空间
    getDownloadSpace({
      "type": "shangchuan"
    }).then(res => {
      if (res.code === '1') {
        this.setState({
          space: ''
        });
        return;
      }

      this.setState({
        space: res.message
      });
    }).catch(err => Promise.reject(err));
  };
  handleBeforeUpload = file => {
    // 上传前判断
    if (this.state.space && this.props.deductionSpaceFlag) {
      message.destroy();
      message.error(this.state.space);
      return false;
    }

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      message.destroy();
      message.error('图片只能上传JPG/PNG格式');
      return false;
    }

    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isLt5M) {
      message.destroy();
      message.error('图片大小不能超过5MB!');
      return false;
    }
  };
  handleChange = info => {
    //
    if (info.file.status === 'uploading') {
      const event = info.event;
      let percent = 0;

      if (event) {
        percent = Math.floor(event.loaded / event.total * 100);
      }

      this.setState({
        loading: true,
        percent: percent,
        imageUrl: ''
      });
      return;
    }

    if (info.file.status === 'done') {
      this.setState({
        loading: false
      });

      if (info.file.response.code === '1') {
        let obj = {
          id: this.props.id,
          resourceId: info.file.response.data.fileId
        };
        this.props.handleImg(obj);
        this.setState({
          imageUrl: info.file.response.data.filePath
        });
        return;
      }

      message.destroy();
      message.error(info.file.response.message);
    }
  };

  render() {
    const {
      data,
      elem,
      defaultValue
    } = this.props;
    const {
      imageUrl,
      loading,
      percent
    } = this.state;
    const {
      getFieldDecorator
    } = this.props.form;
    let sampleUrl = elem.fileUrl || elem.sampleFilePath || ""; //样本图片地址

    let imgCls = classnames('img-uploader', {
      'loading-img-uploader': loading,
      'have-img-uploader': imageUrl
    });
    const uploadButton = <Fragment>
        {loading ? <Progress data-inspector-line="174" data-inspector-column="19" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" type="circle" format={percent => `${percent}%`} percent={percent} /> : <div data-inspector-line="174" data-inspector-column="100" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx">
          <i data-inspector-line="175" data-inspector-column="10" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" className="iconfont iconguanbi" />
          <div data-inspector-line="176" data-inspector-column="10" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" className="ant-upload-text">上传</div>
        </div>}
      </Fragment>;
    const conImg = getFieldDecorator(`img${this.props.id}`, {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = this.state.imageUrl || "";

          if (data.required && val === "") {
            callback('必填项，请输入相关信息');
            return;
          }

          callback();
        }
      }],
      initialValue: defaultValue
    })(<Upload data-inspector-line="195" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" name="avatar" listType="picture-card" headers={{
      Authorization: Local.get('token') ? Local.get('token') : "",
      companyId: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).companyId : '',
      userId: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).userId : ''
    }} disabled={data.frontUpdateFlag === 1} className={imgCls} showUploadList={false} action={window.location.origin.indexOf('localhost') == -1 ? `${window.location.origin}/s/api/saas-business/v1/student/setting/sign/source/upload?domain=${window.location.origin}` : 'http://rel-s.api.yunduoweike.cn/saas-business/v1/student/setting/sign/source/upload?domain=http://ryyzs.rel-s.yunduoketang.cn'} beforeUpload={this.handleBeforeUpload} onChange={this.handleChange}>
        {imageUrl ? <img data-inspector-line="210" data-inspector-column="20" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" src={imageUrl} alt="avatar" style={{
        width: '100%'
      }} /> : uploadButton}
        <span data-inspector-line="211" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" className="retry-btn">重新上传</span>
      </Upload>);
    return <div data-inspector-line="216" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" className="detail-sel-img detail-sel-wrap">
        <Form.Item data-inspector-line="217" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx">
          {conImg}
          <p data-inspector-line="219" data-inspector-column="10" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" className="example-p">
            <span data-inspector-line="220" data-inspector-column="12" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx">{elem && elem.content}</span>
            {elem && sampleUrl && <b data-inspector-line="221" data-inspector-column="34" data-inspector-relative-path="src\\components\\CreateFormItem\\ImgContainer\\index.jsx" onClick={() => Zmage.browsing({
            src: sampleUrl
          })}>查看样本</b> || null}
          </p>
        </Form.Item>
      </div>;
  }

}

ImgContainer.Group = Group;
export default ImgContainer;